import {Floor} from '@lib/store';
import {TFunction} from 'i18next';
import {
  SECTION_ID_ACTIVITY_TYPE,
  SECTION_ID_DESK_AMENITY,
  SECTION_ID_FLOORS,
  SECTION_ID_OCCUPANCY_LEVELS,
  SECTION_ID_WORKSPACE_BOOKING_POLICY,
  constructActivityTypeFilter,
  constructCapacityFilter,
  constructDeskAmenityFilter,
  constructFloorFilter,
  constructOccupancyFilter,
  constructWorkspacePolicyFilter,
} from '../filterConstructors';
import {DeskAmenity, ActivityType} from '@lib/infrastructure';

export const constructHereAndNowWorkspacesFilter = (
  floors: Floor[],
  availableDeskAmenities: DeskAmenity[],
  availableActivityTypes: ActivityType[],
  getDeskAmenityIconName: (id: DeskAmenity) => string,
  isOccupancyEnabled: boolean,
  t: TFunction,
) => {
  const occupancyFilter = isOccupancyEnabled ? constructOccupancyFilter(t) : undefined;
  const capacityFilter = constructCapacityFilter(1);
  const floorFilters = constructFloorFilter(floors, t);
  const deskAmenitiesFilter = constructDeskAmenityFilter(availableDeskAmenities, getDeskAmenityIconName, t);
  const activityTypesFilter = constructActivityTypeFilter(availableActivityTypes, t);
  const workspacePolicyFilter = constructWorkspacePolicyFilter(t);

  return {
    [capacityFilter.sectionId]: capacityFilter,
    [SECTION_ID_FLOORS]: floorFilters,
    [SECTION_ID_DESK_AMENITY]: deskAmenitiesFilter,
    [SECTION_ID_ACTIVITY_TYPE]: activityTypesFilter,
    [SECTION_ID_OCCUPANCY_LEVELS]: occupancyFilter,
    [SECTION_ID_WORKSPACE_BOOKING_POLICY]: workspacePolicyFilter,
  };
};
